import { ApiRetailerPaymentType } from '@vend/types/payment-type'
import {
  PrintReceiptEvent,
  ReceiptTransaction,
} from '../../../../managers/payment-manager'
import {
  usePaymentManager,
  useRegisterManager,
  useTrainingModeManager,
} from '../../../../ng-compat/hooks'
import { $rootScope } from '../../../../ng-compat/imports'
import { useAppSelector } from '../../../../state/hooks'
import { selectCurrentSaleAsSale } from '../../../../state/slices/currentSale/currentSaleSlice'
import { EVENT } from '../../../../constants'

export const usePrintReceipt = () => {
  const paymentManager = usePaymentManager()
  const trainingModeManager = useTrainingModeManager()
  const currentSale = useAppSelector(selectCurrentSaleAsSale)
  const registerManager = useRegisterManager()

  // Pulls up the print dialog using the payment data set on the receipt manager to injected into the receipt.
  const printSignatureSlipReceipt = (
    paymentType?: ApiRetailerPaymentType,
    transaction?: ReceiptTransaction
  ) => {
    const paymentData = {
      isSignatureSlipReceipt: true,
      paymentType,
      transaction,
    }
    $rootScope.$emit(EVENT.PRINT, {
      type: 'receipt-settings-and-template',
      data: {
        trainingModeEnabled: trainingModeManager.trainingModeEnabled,
        sale: currentSale,
        paymentData,
        register: registerManager.getActiveRegister(),
        outlet: registerManager.getActiveOutlet(),
      },
    })
  }

  // Pulls up the print dialog using the receipt html extra set on the receipt manager to injected into the receipt.
  const printIntegratedPaymentReceipt = () => {
    $rootScope.$emit(EVENT.PRINT, {
      type: 'receipt-settings-and-template',
      data: {
        trainingModeEnabled: trainingModeManager.trainingModeEnabled,
        sale: currentSale,
        receiptHtmlExtra: paymentManager.paymentIntegrationReceiptMessage,
        register: registerManager.getActiveRegister(),
        outlet: registerManager.getActiveOutlet(),
      },
    })
  }

  /**
   * Handler for printReceipt event
   */
  const printReceiptHandler = (event: PrintReceiptEvent = {}) => {
    const { paymentType, transaction, isSignatureSlipReceipt } = event
    if (isSignatureSlipReceipt === true) {
      printSignatureSlipReceipt(paymentType, transaction)
    } else {
      paymentManager.updateReceiptMessageOnPrint(event.receiptHtmlExtra)
      printIntegratedPaymentReceipt()
    }
  }

  return printReceiptHandler
}
